import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import StatefulMultiSelect from "@khanacademy/react-multi-select";

export default class TimingsReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            requestedFromPickupDate: moment().toDate(),
            requestedToPickupDate: moment().toDate(),
            isLoading: false,
            getTimingsReportUrl: '/api/v1/portal/portal-admin/timings-jobs-report',
            TimingsReportData: [],
            downloadReportName: 'Timings Report',
            selectedCustomers: [],
            customers: [],
            url: "/api/v1/portal/customers/all/for-dropdown-menu",
        };
        this.handleRequestedFromPickupDateChange = this.handleRequestedFromPickupDateChange.bind(this);
        this.handleRequestedToPickupDateChange = this.handleRequestedToPickupDateChange.bind(this);
        this.handleCustomerSelection = this.handleCustomerSelection.bind(this);
    }
    componentDidMount() {
        let options = [];
        return fetch(this.state.url, {
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
                "Authorization": 'Bearer ' + window.api_token
                , "Accept": 'application/json'
            },
        }).then((responseText) => {
            let response = responseText.json();
            response.then((response) => {
                response.map((customer) => {
                    options.push({
                        label: customer.company.short_name + '-' + customer.name,
                        value: customer.id
                    });
                });
                this.setState({
                    customers: options,
                    isLoading: false
                });
            });
        });
    }
    handleRequestedFromPickupDateChange(date) {
        this.setState({ requestedFromPickupDate: date })
    }
    handleRequestedToPickupDateChange(date) {
        this.setState({ requestedToPickupDate: date })
    }
    handleCustomerSelection(selectedCustomers) {
        this.setState({ selectedCustomers });
    }
    handleInvoicedJobsReportGeneration(e) {
        this.setState({ isLoading: true });
        let url = this.state.getTimingsReportUrl;
        return fetch(url, {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
                "Authorization": 'Bearer ' + window.api_token
                , "Accept": 'application/json'
            },
            body: JSON.stringify({
                customer_ids: this.state.selectedCustomers,
                requested_pickup_date_from: moment(this.state.requestedFromPickupDate).format("YYYY-MM-DD"),
                requested_dropoff_date_to: moment(this.state.requestedToPickupDate).format("YYYY-MM-DD"),
            }),
        }).then((responseText) => {
            let response = responseText.json();
            response.then((response) => {
                this.setState({
                    TimingsReportData: response,
                    isLoading: false
                })
            });
        });
    }
    download(filename, text) {
        filename = filename + ' From ' + moment(this.state.requestedFromPickupDate).format("YYYY-MM-DD") + ' To ' + moment(this.state.requestedToPickupDate).format("YYYY-MM-DD") + '.csv';
        let element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }
    render() {
        let TimingJobs = [];
        const { selectedCustomers } = this.state;
        let downloadableCsvDataInvoiced = "JOB NUMBER, VEHICLE REG, REQUIRED PICK UP DATE, REQUIRED DROP OFF DATE, CUSTOMER NAME, PICKUP TOWN, PICKUP POSTCODE, DROPOFF TOWN, DROPOFF POSTCODE, DATE DRIVER COLLECTED, DATE DRIVER DELIVERED, NUMBER OF DAYS LATE ON COLLECTION, NUMBER OF DAYS LATE ON DELIVERY\n";
        if (this.state.TimingsReportData.length > 0) {
            this.state.TimingsReportData.map((currentJob, index) => {
                let isSplitJobPartA = currentJob.is_split_job
                let hasSplitJobs = currentJob.has_split_jobs
                let isSplitJob = currentJob.is_split_job
                let joburl = "/jobs/view/" + currentJob.id;
                if (TimingJobs) {
                    TimingJobs.push(
                        <tr key={index}>
                            <td className="job-ref-font16">
                                {(hasSplitJobs) ? <sup><i style={{fontSize:'15px'}} className="fa fa-strikethrough text-danger"></i>&nbsp;</sup> : null}
                                <a href={joburl} target="_blank">{(currentJob.id?currentJob.id:'')}</a>
                                {(isSplitJob) ? <sub>&nbsp;<i style={{fontSize:'15px'}} className="fa fa-strikethrough text-primary"></i></sub> : null}
                            </td>
                            <td>{(currentJob.registration_number?currentJob.registration_number:'')}</td>
                            <td>{(currentJob.required_pickup_date?currentJob.required_pickup_date:'')}</td>
                            <td>{(currentJob.required_dropoff_date?currentJob.required_dropoff_date:'')}</td>
                            <td>{(currentJob.name?currentJob.name:'')}</td>
                            <td>{(currentJob.pickup_town_city?currentJob.pickup_town_city:'')}</td>
                            <td>{(currentJob.pickup_postcode?currentJob.pickup_postcode:'')}</td>
                            <td>{(currentJob.dropoff_town_city?currentJob.dropoff_town_city:'')}</td>
                            <td>{(currentJob.dropoff_postcode?currentJob.dropoff_postcode:'')}</td>
                            <td>{(currentJob.driver_collected_date?currentJob.driver_collected_date:'')}</td>
                            <td>{(currentJob.driver_delivered_date?currentJob.driver_delivered_date:'')}</td>
                            <td>{(currentJob.days_late_on_collection)}</td>
                            <td>{(currentJob.days_late_on_delivery)}</td>
                        </tr>
                    );
                    if (currentJob.is_split_job !== 1) {
                        downloadableCsvDataInvoiced = downloadableCsvDataInvoiced +
                        '"' + (currentJob.id ? currentJob.id : '') + '",' +
                        '"' + (currentJob.registration_number ? currentJob.registration_number : '') + '",' +
                        '"' + (currentJob.required_pickup_date ? currentJob.required_pickup_date : '') + '",' +
                        '"' + (currentJob.required_dropoff_date ? currentJob.required_dropoff_date : '') + '",' +
                        '"' + (currentJob.name ? currentJob.name : '') + '",' +
                        '"' + (currentJob.pickup_town_city ? currentJob.pickup_town_city : '') + '",' +
                        '"' + (currentJob.pickup_postcode ? currentJob.pickup_postcode : '') + '",' +
                        '"' + (currentJob.dropoff_town_city ? currentJob.dropoff_town_city : '') + '",' +
                        '"' + (currentJob.dropoff_postcode ? currentJob.dropoff_postcode : '') + '",' +
                        '"' + (currentJob.driver_collected_date ? currentJob.driver_collected_date : '') + '",' +
                        '"' + (currentJob.driver_delivered_date ? currentJob.driver_delivered_date : '') + '",' +
                        '"' + (currentJob.days_late_on_collection) + '",' +
                        '"' + (currentJob.days_late_on_delivery) + '",' +
                        '""\n';
                    }
                }
            });
        } else {
            TimingJobs.push(
                <tr key='no-records'><td colSpan="26" className='text-center'>No Records</td></tr>
            );
        }

        return (
            <div className="container-fluid">
                <div className="col-md-6">
                    <h2>Timings Report</h2>
                    <br />
                </div>

                <div className="row">
                    <div className="col-md-2">
                        <label><h5>Start Date:</h5></label><br />
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleRequestedFromPickupDateChange} selected={this.state.requestedFromPickupDate} />
                    </div>
                    <div className="col-md-2">
                        <label><h5>End Date:</h5></label><br />
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleRequestedToPickupDateChange} selected={this.state.requestedToPickupDate} />
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-3 col-sm-12">
                        <label><h5>Select Customer</h5></label><br />
                        <div>
                            <StatefulMultiSelect
                                options={this.state.customers}
                                selected={selectedCustomers}
                                onSelectedChanged={this.handleCustomerSelection}
                                overrideStrings={{
                                    selectSomeItems: "Select Customers...",
                                    allItemsAreSelected: "All Customers are Selected",
                                    selectAll: "Select All",
                                    search: "Search Customer",
                                }}
                            />
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <button className="btn btn-lg btn-success invoiced-btn-margin" onClick={(e) => this.handleInvoicedJobsReportGeneration(e)}>
                                <i className="fa fa-save"></i> Generate Timings Report
                            </button>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <button className="btn btn-primary btn-lg invoiced-btn-margin"
                                onClick={(e) => {
                                    this.download(this.state.downloadReportName, downloadableCsvDataInvoiced);
                                }}>
                                <i className="fa fa-download"></i> Download Timings Report
                            </button>
                        </div>
                    </div>
                </div>
                {/* <div class="row row-spacer-1">
                    
                </div> */}
                <div className="row">
                    <div className="col-md-3"><label className="alert alert-primary"><b>{this.state.TimingsReportData.length} jobs found..</b></label></div>
                </div>
                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <div className="daily-delivered-report-tbl-scroll">
                            <table className="daily-delivered-report-tbl">
                                <thead className="daily-delivered-report-tbl-head">
                                    <tr>
                                        <th>Job number</th>
                                        <th>Vehicle Reg</th>
                                        <th>Required Pick up Date</th>
                                        <th>Required Drop Off Date</th>
                                        <th>Customer Name</th>
                                        <th>Pickup Town</th>
                                        <th>Pickup Postcode</th>
                                        <th>Dropoff Town</th>
                                        <th>Dropoff Postcode</th>
                                        <th>Date driver collected</th>
                                        <th>Date Driver delivered</th>
                                        <th>Number of Days late on Collection</th>
                                        <th>Number of days late on Delivery</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.isLoading ?
                                        (<tr><td colSpan="26"><span className="add-loading-text">
                                            <i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :
                                        TimingJobs
                                    }
                                </tbody>
                            </table>
                        </div>
                        <br /><br /><br />
                    </div>
                </div>
            </div>
        );
    }
}
if (document.getElementById('react-component-g4-logistics-portal-timings_report')) {
    ReactDOM.render(
        <TimingsReport message_if_none='Nothing to report on.' />,
        document.getElementById('react-component-g4-logistics-portal-timings_report')
    );
}
